@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<div class="header">
  <span class="time-span">

    <span class="date-picker">
      <button mat-flat-button mwlCalendarPreviousView class="nav-button-left"
        [view]="view" [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <div class="current" mwlCalendarToday [(viewDate)]="viewDate">
        {{ viewDate | calendarDate:(view + 'ViewTitle'):locale:weekStartsOn }}
      </div>

      <button mat-flat-button mwlCalendarNextView class="nav-button-right"
        [view]="view" [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </span>

    <mat-button-toggle-group class="view-toggle" [(ngModel)]="view">
      <mat-button-toggle value="month">{{language.Monat | translationPipe}}</mat-button-toggle>
      <mat-button-toggle value="week">{{language.Woche | translationPipe}}</mat-button-toggle>
      <mat-button-toggle value="day">{{language.Tag | translationPipe}}</mat-button-toggle>
    </mat-button-toggle-group>

    <mat-slide-toggle class="weekend-toggle"
      [(ngModel)]="withWeekend"
      (change)="toggleWithWeekend(withWeekend)">
      {{language.Wochenende | translationPipe}}
    </mat-slide-toggle>

    <form [formGroup]="FormGroup" (ngSubmit)="searchEvents(filterValue)">    
      <mat-form-field class="main-filter" appearance="outline" subscriptSizing="dynamic" >
        <mat-icon matPrefix class="filter-icon" (click)="searchEvents(filterValue)" matBadge="{{searchevents.length}}" matBadgePosition="above after" matBadgeColor="primary" [matBadgeHidden]="!isSet">search</mat-icon>
        <input #input matInput type="search" placeholder="Suche" formControlName="searchControl"
           
            (input)="onInput(input.value)"  
        />
        <div matSuffix class="suffix-container">
            @if(searchevents.length>1)
            {
              <mat-icon matPrefix class="filter-icon" (click)="searchSkipEvent(-1)">chevron_left</mat-icon>
              <mat-icon matPrefix class="filter-icon" (click)="searchSkipEvent(1)">chevron_right</mat-icon>
            }  

            @if(isSet) {
              <mat-icon matPrefix class="filter-icon" (click)="clear()">close</mat-icon>


            }
        </div>
      </mat-form-field>
    </form>
  </span>
</div>

<ng-template #monthEventTemplate let-event="event" let-view="view">
    <div class="custom-month-event">
        <strong>{{ event.title }}</strong>    
        <div class="event-content">starthour{{ event.meta?.description }}</div>
    </div>
</ng-template>

<div [ngSwitch]="view">
  <custom-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events" [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen" [weekStartsOn]="weekStartsOn" 
      [excludeDays]="excludeDays" (dayClicked)="dayClicked($event.day)" (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)">
  </custom-month-view>
  
  <mwl-calendar-week-view
    *ngSwitchCase="CalendarView.Week"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [weekStartsOn]="weekStartsOn"
    [dayStartHour]=starthour 
    [dayEndHour]=endhour
    [excludeDays]="excludeDays"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
  >
  </mwl-calendar-week-view>
  
  <mwl-calendar-day-view
    *ngSwitchCase="CalendarView.Day"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [dayStartHour]=starthour [dayEndHour]=endhour
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
  >
  </mwl-calendar-day-view>

  
</div>


